export default `
  mutation cancelSubscription ($feedback: String!) {
    cancelSubscription (feedback: $feedback) {
      success
      message
    }
  }
`
